import { render, staticRenderFns } from "./quizBanner.vue?vue&type=template&id=5aa152ee&scoped=true&"
import script from "./quizBanner.vue?vue&type=script&lang=js&"
export * from "./quizBanner.vue?vue&type=script&lang=js&"
import style0 from "./quizBanner.vue?vue&type=style&index=0&id=5aa152ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa152ee",
  null
  
)

export default component.exports